export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '1fb6d06', dateTime: 1784768024239 };